import { useEffect, useRef } from "react";

const AlertModal = ({ open, message, onClose }) => {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (!dialogRef.current) return;

    if (open) {
      dialogRef.current.showModal();
    } else {
      dialogRef.current.close();
    }
  }, [open]);

  // Handle Escape key to close modal (standard dialog behavior)
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      onClose();
    }
  };

  return (
    <dialog
      ref={dialogRef}
      className="fixed inset-0 z-50 bg-transparent backdrop:bg-text-primary/50"
      onClose={onClose}
      // Improved accessibility: added aria-labelledby for dialog title
      aria-labelledby="alert-modal-title"
      // Improved accessibility: prevent closing by clicking backdrop
      onCancel={(e) => e.preventDefault()}
      onKeyDown={handleKeyDown}
    >
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <div className="relative w-full max-w-sm transform overflow-hidden rounded-lg bg-text-strong text-left shadow-xl outline outline-1 outline-white/10">
          <div className="px-6 py-5">
            {/* Improved accessibility: added id for aria-labelledby reference */}
            <h3
              id="alert-modal-title"
              className="text-base font-semibold text-white mb-2"
            >
              {message}
            </h3>
          </div>

          <div className="px-6 py-3 flex justify-end bg-text-secondary/30">
            <button
              onClick={onClose}
              className="rounded-md bg-info px-4 py-2 text-sm font-semibold text-white hover:bg-info-soft"
              // Improved accessibility: ensure button is keyboard accessible
              type="button"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default AlertModal;
